import { BaseSingletonState, createInitialSingletonState } from '../base-store/base.state'
import { Doctor } from '../interfaces/doctor'
import { Operator } from '../interfaces/operator'

export interface UserState extends BaseSingletonState {
  user: Doctor | Operator | null
  token: string | null
  refreshToken: string | null
  csrfToken: string | null
  mfaToken: string | null
  passwordExpiredEmail: string | null
}

export const initialUserState: UserState = {
  ...createInitialSingletonState(),
  user: null,
  token: null,
  refreshToken: null,
  csrfToken: null,
  mfaToken: null,
  passwordExpiredEmail: null,
}
